var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 40",
    role: "img",
    "aria-label": "Zoho",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 40,
    rx: 6,
    fill: "#E42527"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 26,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "ZOHO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoho);
export default __webpack_public_path__ + "static/media/zoho.699285b53012469154980ce0a7a2488d.svg";
export { ForwardRef as ReactComponent };